import { render, staticRenderFns } from "./MailMagazineCheckItem.vue?vue&type=template&id=147cfe1a&scoped=true&"
import script from "./MailMagazineCheckItem.vue?vue&type=script&lang=ts&"
export * from "./MailMagazineCheckItem.vue?vue&type=script&lang=ts&"
import style0 from "./MailMagazineCheckItem.vue?vue&type=style&index=0&id=147cfe1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147cfe1a",
  null
  
)

export default component.exports